<template>
    <div v-loading="sloading">
        <div class="container">
            <div class="containerBox">
                <div class="search">
                    <div class="searchBox">
                        <span class="searchtitle">VIN码/车架号</span>
                        <el-autocomplete ref="autocomplete" popper-class="vin-input" class="vin-inputcls" clearable
                            v-model.trim="vin" v-filter-special-char="vin" :fetch-suggestions="querySearchAsync"
                            placeholder="请输入17位车架号码" @select="getTableData" @input="dataInput"
                            v-autocomplete-scroll="handleScroll">
                            <template slot-scope="{ item }" class="my-autocomplete">
                                <div class="i-value">{{ item.value }}</div>
                                <span class="i-text">{{ item.text }}</span>
                            </template></el-autocomplete>
                        <el-button icon="el-icon-search" class="btn-primary" @click="getTableData">查询</el-button>
                    </div>
                    <div id="uploadArea" class="el-upload el-upload--text" ref="uploadArea">
                        <div class="el-upload-dragger">
                            <em class="upload-btn" @click="uploadBtnClick">上传图片</em>
                            <p>也可拖拽图片到此处自动识别，或在微信/QQ截图后点击此处后Ctrl+V</p>
                            <input type="file" ref="uploadBtn" accept="image/*" @change="uploadBtnChange($event)"
                                style="opacity: 0; display: none" />
                        </div>
                    </div>
                </div>
                <div class="search-result">
                    <div class="result-row">
                        <div class="result-cell">
                            <div class="firstkey">品牌</div>
                            <div class="firstvalue">
                                <span>{{ vinData.BrandName }}</span>
                                &nbsp;&nbsp;
                                <img :src="downloadUrl + vinData.BrandLogo" alt :onerror="defaultImg"
                                    v-if="vinData.BrandLogo" />
                            </div>
                        </div>
                        <div class="result-cell">
                            <div class="firstkey">车系</div>
                            <div class="firstvalue">
                                <span>{{ vinData.CarLine }}</span>
                                &nbsp;&nbsp;
                                <img :src="downloadUrl + vinData.AutoImg" alt :onerror="defaultImg"
                                    v-if="vinData.AutoImg" />
                            </div>
                        </div>
                        <div class="result-cell">
                            <div class="firstkey">生产商</div>
                            <div class="firstvalue">
                                <span>{{ vinData.Manufacturer }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="result-row">
                        <div class="result-cell">
                            <div class="key">车型名称</div>
                            <div class="value">
                                <span>{{ vinData.ModelName }}</span>
                            </div>
                        </div>
                        <div class="result-cell">
                            <div class="key">年款</div>
                            <div class="value">
                                <span>{{ vinData.ModelYear }}</span>
                            </div>
                        </div>
                        <div class="result-cell">
                            <div class="key">座位数量</div>
                            <div class="value">
                                <span>{{ vinData.SeatNum }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="result-row">
                        <div class="result-cell">
                            <div class="key">发动机</div>
                            <div class="value">
                                <span>{{ vinData.EngineType }}</span>
                            </div>
                        </div>
                        <div class="result-cell">
                            <div class="key">生产年份</div>
                            <div class="value">
                                <span>{{ vinData.MadeYear }}</span>
                            </div>
                        </div>
                        <div class="result-cell">
                            <div class="key">功率/转速(kw/R)</div>
                            <div class="value">
                                <span>{{ vinData.Power }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="result-row">
                        <div class="result-cell">
                            <div class="key">排量</div>
                            <div class="value">
                                <span>{{ vinData.OutputVolume }}</span>
                            </div>
                        </div>
                        <div class="result-cell">
                            <div class="key">燃料</div>
                            <div class="value">
                                <span>{{ vinData.FuelType }}</span>
                            </div>
                        </div>
                        <div class="result-cell">
                            <div class="key">发动机缸数</div>
                            <div class="value">
                                <span>{{ vinData.CylinderNumber }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="result-row">
                        <div class="result-cell">
                            <div class="key">变速器</div>
                            <div class="value">
                                <span>{{ vinData.TransmissionType }}</span>
                            </div>
                        </div>
                        <div class="result-cell">
                            <div class="key">气缸形式</div>
                            <div class="value">
                                <span>{{ vinData.CylinderForm }}</span>
                            </div>
                        </div>
                        <div class="result-cell">
                            <div class="key">车身形式</div>
                            <div class="value">
                                <span>{{ vinData.CarBody }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="result-row">
                        <div class="result-cell">
                            <div class="key">排放标准</div>
                            <div class="value">
                                <span>{{ vinData.EffluentStandard }}</span>
                            </div>
                        </div>
                        <div class="result-cell">
                            <div class="key">驱动类型</div>
                            <div class="value">
                                <span>{{ vinData.DriveStyle }}</span>
                            </div>
                        </div>
                        <div class="result-cell">
                            <div class="key">燃料标号</div>
                            <div class="value">
                                <span>{{ vinData.FuelNum }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="result-row">
                        <div class="result-cell">
                            <div class="key">车门数量</div>
                            <div class="value">
                                <span>{{ vinData.DoorNum }}</span>
                            </div>
                        </div>
                        <div class="result-cell">
                            <div class="key">档位数</div>
                            <div class="value">
                                <span>{{ vinData.GearsNum }}</span>
                            </div>
                        </div>
                        <div class="result-cell">
                            <div class="key">车辆类型</div>
                            <div class="value">
                                <span>{{ vinData.CarType }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="result-row">
                        <div class="result-cell">
                            <div class="key">车身重量</div>
                            <div class="value">
                                <span>{{ vinData.CarWeight }}</span>
                            </div>
                        </div>
                        <div class="result-cell" style="width: 100%">
                            <div class="key">销售名称</div>
                            <div class="value" style="width: 500px">
                                <span style="white-space:nowrap;text-align:center;overflow:hidden;">{{ vinData.SaleName
                                }}</span>
                            </div>
                        </div>
                        <div class="result-cell" style="width: 0; display: none">
                            <div class="key"></div>
                            <div class="value">
                                <span></span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="search-footer">
                    <p v-if="vinData && !vinData.IsCorrect && vin" style="color:red;margin-bottom:5px;font-weight=500;">
                        VIN不符合国际编码规则，请检查VIN码是否正确!</p>
                    <div class="opbtn">
                        <el-button v-if="Source == '1'" class="btn-primary" @click="searchPart">匹配配件（{{ partCount
                        }}）</el-button>
                        <el-button v-if="Source == '0' && vinData" class="btn-primary" @click="gotoCreatOrder">去开单（{{
                            partCount }}）</el-button>
                        <el-button v-if="showEPCBtn && vinData && vinData.Source == 'JingYou' && vinData.ThirdId"
                            class="btn-primary" @click="showEPC">车辆结构（EPC）</el-button>
                    </div>
                    <p v-if="Source == '0' && partCount == 0 && vinData && vin">该车型未找到匹配的配件，可以先对配件进行车型的关联哟</p>
                </div>
            </div>
        </div>
        <el-dialog :title="epcTitle" :close-on-click-modal="false" :visible.sync="epcVisible" append-to-body v-dialog-drag
            lock-scroll :modal="false" id="epc-veh-dialog" style="margin-left: -600px" width="1350px">
            <div v-if="epcVisible">
                <Epc ref="Epc" :visible="epcVisible" :vehicleId="vinData.ThirdId" :vin="vin" />
            </div>
        </el-dialog>
    </div>
</template>
<script>
import Epc from '@/components/business/goods/vinEPCDatas';
export default {
    name: 'VinEPCDatas',
    components: {
        Epc
    },
    props: {
        Source: { type: String, default: '0' },
        VIN: { type: String }
    },
    data() {
        return {
            sloading: false,
            defaultImg: 'this.src="' + this.$util.DEFAULT_IMAGE + '"',
            downloadUrl: this.$util.QN_URL_BASE,
            vin: '',
            vinData: {},
            vinCheckMsg: '',
            partCount: 0,
            token: this.$util.getLocalStorage('userMsg') ? this.$util.getLocalStorage('userMsg').Token : '',
            pageIndex: 1,
            showEPCBtn: false,
            epcVisible: false,
            epcTitle: '',
            stopLoadHis: false,
            cacheVinList: []
        };
    },
    mounted() {
        this.$nextTick(() => {
            let uploadArea = document.querySelector('#uploadArea');
            uploadArea.addEventListener('dragenter', this.onDrag, false);
            uploadArea.addEventListener('dragover', this.onDrag, false);
            uploadArea.addEventListener('drop', this.onDrop, false);
            document.addEventListener('paste', this.handlePaste, false);
        });

        if (this.VIN) {
            this.vin = this.VIN;
            this.getTableData();
        }
        this.getConfigByCodes();
    },
    beforeDestroy() {
        //注销粘贴事件
        document.removeEventListener('paste', this.handlePaste, false);
    },
    directives: {
        'autocomplete-scroll': {
            bind(el, binding, vnode) {
                // 此处为了简单，直接判断触底了
                function handleScroll(e) {
                    let isBottom = e.target.clientHeight + e.target.scrollTop >= e.target.scrollHeight - 1;
                    if (isBottom && !vnode.context.loading) {
                        binding.value();
                    }
                }
                // 监听滚动
                let wrapDom = el.querySelector('.el-autocomplete-suggestion__wrap');
                el.__handleScroll__ = handleScroll;
                el.__wrapDom__ = wrapDom;
                wrapDom.addEventListener('scroll', handleScroll, false);
            },

            unbind(el, binding, vnode) {
                // 解除事件监听
                el.__wrapDom__.removeEventListener('scroll', el.__handleScroll__, false);
            }
        }
    },
    methods: {
        search(key) {
            return new Promise(resolve => {
                this.$util
                    .axiosGet({
                        url: '/api/EntpInfoManagement/GetVinSearchHisList',
                        data: {
                            VIN: key,
                            Page: this.pageIndex,
                            Limit: 10
                        },
                        hideLoading: true
                    })
                    .then(res => {
                        resolve(res.data);
                    });
            });
        },
        async handleScroll() {
            let that = this;
            if (!that.stopLoadHis) {
                that.pageIndex++;
                that.search(that.vin).then(data => {
                    let vinList = [];
                    if (data) {
                        that.stopLoadHis = data.length < 10;
                        for (let i in data) {
                            vinList.push({
                                value: data[i].Value,
                                text: data[i].Text
                            });
                        }
                    }
                    that.$refs['autocomplete'].$data.suggestions.push(...vinList);
                });
            }
        },
        querySearchAsync(queryString, cb) {
            let that = this;
            that.pageIndex = 1;
            that.$util.searchVINHis(queryString, that.pageIndex).then(res => {
                if (res.errcode == 0) {
                    that.stopLoadHis = false;
                    let vinList = [];
                    if (res.data) {
                        that.stopLoadHis = res.data.length < 10;
                        for (let i in res.data) {
                            vinList.push({
                                value: res.data[i].Value,
                                text: res.data[i].Text
                            });
                        }
                        that.cacheVinList = vinList;
                    }
                    cb(vinList);
                }
                else
                    cb(that.cacheVinList);
            });
        },
        searchData(item) {
            this.vin = item;
            this.getTableData();
        },
        // 提交数据
        getTableData() {
            this.vinCheckMsg = '';
            // LFV2A1157A3049579 车架号
            let reg = /^[a-zA-Z0-9]{17}$/;
            if (!reg.test(this.vin)) {
                this.$util.warningMsg('请输入正确的车架号');
                return;
            }
            this.sloading = true;
            this.$util
                .axiosGet({
                    url: '/api/Auto/GetAutoSerieVINDatas',
                    data: {
                        vin: this.vin
                    },
                    hideLoading: true
                })
                .then(res => {
                    if (res.errcode != 201) {
                        this.vinData = {};
                        if (res.data && res.data.IsCorrect) {
                            let data = res.data;
                            this.vinData = data;
                            if (data.AutoSerieId) this.getPartMacthCount(data.AutoSerieId);
                        } else {
                            this.$util.errorMsg(res.errmsg);
                        }
                    }
                    this.sloading = false;
                })
                .catch(() => {
                    this.sloading = false;
                });
        },
        translateText(txt) {
            if (txt) {
                this.vin = txt;
                this.getTableData();
            }
        },
        getPartMacthCount(autoSerieId) {
            this.$util
                .axiosGet({
                    url: '/api/EntpGoods/GetMyVINPartDatas',
                    data: {
                        autoSeriesId: autoSerieId
                    },
                    hideLoading: false
                })
                .then(res => {
                    if (res.data) {
                        this.partCount = res.data;
                    }
                })
                .catch(() => { });
        },
        gotoCreatOrder() {
            let that = this;
            if (!this.vinData.AutoSerieId || this.partCount == 0) {
                that.$confirm('未匹配到对应的车型或配件，仍要继续开单吗？', '', {
                    type: 'warning',
                    distinguishCancelAndClose: true
                })
                    .then(() => {
                        let params = {
                            VIN: this.vin,
                            AutoSeriesId: this.vinData.AutoSerieId,
                            ModelName: this.vinData.ModelName,
                            AutoSeries:
                                this.vinData.BrandName +
                                ' ' +
                                this.vinData.ModelName +
                                ' ' +
                                this.vinData.MadeYear +
                                ' ' +
                                this.vinData.OutputVolume +
                                ' ' +
                                this.vinData.EngineType
                        };
                        this.$util.setLocalStorage('vin_createParams', params); //保存当前查询参数，返回页面时使用
                        this.$emit('closeDialog');
                        this.$router.push(`/salesManage/salesOrder/edit_v3?type=0`);
                    })
                    .catch(() => { });
            } else {
                // if (this.vinData.AutoSerieId && this.partCount > 0) {
                let params = {
                    VIN: this.vin,
                    AutoSeriesId: this.vinData.AutoSerieId,
                    ModelName: this.vinData.ModelName,
                    AutoSeries:
                        this.vinData.BrandName + ' ' + this.vinData.ModelName + ' ' + this.vinData.MadeYear + ' ' + this.vinData.OutputVolume + ' ' + this.vinData.EngineType
                };
                this.$util.setLocalStorage('vin_createParams', params); //保存当前查询参数，返回页面时使用
                this.$emit('closeDialog');
                this.$router.push(`/salesManage/salesOrder/edit_v3?type=0`);
                // }
            }
        },
        searchPart() {
            let params = {
                VIN: this.vin,
                AutoSeriesId: this.vinData.AutoSerieId,
                ModelName: this.vinData.ModelName,
                AutoSeries: this.vinData.BrandName + ' ' + this.vinData.ModelName + ' ' + this.vinData.MadeYear + ' ' + this.vinData.OutputVolume + ' ' + this.vinData.EngineType
            };
            this.$util.setLocalStorage('vin_createParams', params);
            this.$emit('closeDialog');
        },
        uploadBtnClick() {
            this.$refs.uploadBtn.click();
        },
        uploadBtnChange(e) {
            let that = this;
            let imgfile = this.$refs.uploadBtn;

            for (let i = 0; i < imgfile.files.length; i++) {
                if (!that.uploadCheck(imgfile.files[i])) {
                    return;
                }

                that.sloading = true;
                let reader = new FileReader();
                reader.readAsDataURL(imgfile.files[i]);
                reader.onload = function () {
                    let imgBase64 = this.result.split(',')[1];
                    let fd = new window.FormData();
                    fd.append('imgBase64', imgBase64);
                    let xhr = new XMLHttpRequest();
                    xhr.open('POST', '/api/Auto/VINImgRecognition', true);
                    xhr.setRequestHeader('access-key', that.token);
                    xhr.setRequestHeader('reqApp', 'yqgPC');
                    xhr.onload = () => {
                        if (xhr.status === 200) {
                            let res = JSON.parse(xhr.responseText);
                            if (res.errcode == 0) {
                                let data = res.data;
                                if (data && data.length > 0) {
                                    that.vin = data[0];
                                    if (that.vin.length == 17) {
                                        that.getTableData();
                                    }
                                } else {
                                    that.$util.errorMsg('未识别到VIN码');
                                }
                                that.sloading = false;
                            } else {
                                that.$util.errorMsg('未识别到VIN码');
                            }
                        }
                        that.sloading = false;
                    };
                    xhr.onerror = () => {
                        that.$util.errorMsg('识别失败');
                        that.sloading = false;
                    };
                    xhr.send(fd);
                };
            }
        },
        uploadCheck(file) {
            const isJPG = file.type === 'image/jpeg';
            const isGIF = file.type === 'image/gif';
            const isPNG = file.type === 'image/png';
            const isBMP = file.type === 'image/bmp';
            //改成10M
            const isLt20M = file.size / 1024 / 1024 < 20;
            if (!isJPG && !isGIF && !isPNG && !isBMP) {
                this.$util.warningMsg('上传图片必须是JPG/GIF/PNG/BMP 格式!');
            }
            if (!isLt20M) {
                this.$util.warningMsg('上传图片大小不能超过 20MB!');
            }
            return (isJPG || isBMP || isGIF || isPNG) && isLt20M;
        },
        //拖拽上传
        onDrop: function (e) {
            e.stopPropagation();
            e.preventDefault();
            let that = this;
            let dt = e.dataTransfer;

            if (dt.files.length > 1) {
                this.$util.warningMsg('只能上传一张图片!');
                return;
            }

            for (let i = 0; i < dt.files.length; i++) {
                if (!that.uploadCheck(dt.files[i])) {
                    return;
                }

                that.sloading = true;
                let reader = new FileReader();
                reader.readAsDataURL(dt.files[i]);
                reader.onload = function () {
                    let imgBase64 = this.result.split(',')[1];
                    let fd = new window.FormData();
                    fd.append('imgBase64', imgBase64);
                    let xhr = new XMLHttpRequest();
                    xhr.open('POST', '/api/Auto/VINImgRecognition', true);
                    xhr.setRequestHeader('access-key', that.token);
                    xhr.setRequestHeader('reqApp', 'yqgPC');
                    xhr.onload = () => {
                        if (xhr.status === 200) {
                            let res = JSON.parse(xhr.responseText);
                            if (res.errcode == 0) {
                                let data = res.data;
                                if (data && data.length > 0) {
                                    that.vin = data[0];
                                    if (that.vin.length == 17) {
                                        that.getTableData();
                                    }
                                } else {
                                    that.$util.errorMsg('未识别到VIN码');
                                }
                                that.sloading = false;
                            } else {
                                that.$util.errorMsg('未识别到VIN码');
                            }
                        }
                        that.sloading = false;
                    };
                    xhr.onerror = () => {
                        that.$util.errorMsg('识别失败');
                        that.sloading = false;
                    };
                    xhr.send(fd);
                };
            }
        },
        // 监听粘贴操作
        handlePaste(event) {
            let that = this;
            const items = (event.clipboardData || window.clipboardData).items;
            let file = null;

            if (!items || items.length === 0) {
                this.$message.error('当前浏览器不支持粘贴模式');
                return;
            }
            // 搜索剪切板items
            for (let i = 0; i < items.length; i++) {
                if (items[i].type.indexOf('image') !== -1) {
                    file = items[i].getAsFile();
                    break;
                }
            }
            if (!file) {
                return;
            }

            if (!that.uploadCheck(file)) {
                return;
            }
            that.sloading = true;
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = function (event) {
                let imgBase64 = this.result.split(',')[1];
                let fd = new window.FormData();
                fd.append('imgBase64', imgBase64);
                let xhr = new XMLHttpRequest();
                xhr.open('POST', '/api/Auto/VINImgRecognition', true);
                xhr.setRequestHeader('access-key', that.token);
                xhr.setRequestHeader('reqApp', 'yqgPC');
                xhr.onload = () => {
                    if (xhr.status === 200) {
                        let res = JSON.parse(xhr.responseText);
                        if (res.errcode == 0) {
                            let data = res.data;
                            if (data && data.length > 0) {
                                that.vin = data[0];
                                if (that.vin.length == 17) {
                                    that.getTableData();
                                }
                            } else {
                                that.$util.errorMsg('未识别到VIN码');
                            }
                            that.sloading = false;
                        } else {
                            that.$util.errorMsg('未识别到VIN码');
                        }
                    }
                    that.sloading = false;
                };
                xhr.onerror = () => {
                    that.$util.errorMsg('识别失败');
                    that.sloading = false;
                };
                xhr.send(fd);
            };
        },
        onDrag: function (e) {
            e.stopPropagation();
            e.preventDefault();
        },
        dataInput(e) {
            if (e && e.length == 17) {
                if (!this.vinData.IsCorrect) this.vinData.IsCorrect = true;
            }
        },
        getConfigByCodes() {
            return new Promise(resolve => {
                let codes = ['qpepccx'];
                this.$util.getSysConfigs(codes).then(data => {
                    if (data) {
                        for (let i = 0; i < data.length; i++) {
                            let code = data[i].Code;
                            let result = data[i].Result;
                            switch (code) {
                                case 'qpepccx':
                                    this.showEPCBtn = result;
                                    break;
                            }
                        }
                    }
                    resolve();
                });
            });
        },
        showEPC() {
            if (this.vinData && this.vinData.ThirdId && this.vinData.Source == 'JingYou') {
                this.epcVisible = true;
                this.epcTitle = '【' + this.vinData.SaleName + '】装配图选配件';
            } else {
                this.$util.errorMsg('该车型暂未关联EPC数据，可反馈给技术人员哦');
            }
        }
    }
};
</script>
<style lang="less" scoped>
.vinCheckMsg {
    justify-content: left !important;
    width: 34% !important;
    padding-top: 10px !important;
    color: red;
}

.searchtitle {
    font-size: 18px;
    font-weight: bold;
    margin-right: 5px;
}

.search-result {
    width: 900px;
    margin: 0 auto;
    padding-top: 10px;
    border-bottom: 1px solid #dcdfe6;

    .result-row {
        display: flex;
        border-right: 1px solid #dcdfe6;
    }

    .result-cell {
        width: 50%;
        display: flex;
        align-items: center;
        border-top: 1px solid #dcdfe6;

        .firstkey {
            height: 60px;
            line-height: 60px;
            width: 100px;
            text-align: center;
            background-color: #f2f6fc;
            border-left: 1px solid #dcdfe6;
            padding-right: 10px;
        }

        .firstvalue {
            width: 200px;
            height: 60px;
            line-height: 60px;
            text-align: center;
            border-left: 1px solid #dcdfe6;

            img {
                height: 50px;
            }
        }

        .key {
            height: 50px;
            line-height: 50px;
            width: 100px;
            text-align: center;
            background-color: #f2f6fc;
            border-left: 1px solid #dcdfe6;
            padding-right: 10px;
        }

        .value {
            width: 200px;
            height: 50px;
            line-height: 50px;
            text-align: center;
            border-left: 1px solid #dcdfe6;
        }
    }
}

.search-footer {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 10px;
    width: 100%;
    // height: 80px;
    display: flex;
    justify-content: space-evenly;
    align-content: center;

    .el-button {
        width: 150px;
    }

    .opbtn {
        display: flex;
        flex-direction: row;
    }
}

.container {
    display: flex;
    flex-direction: column;
    align-items: center;
    align-content: center;
}

.containerBox {
    width: 100%;
}

.search {
    width: 100%;
    display: flex;
    flex-flow: column;
    justify-content: center;
    align-content: center;
    align-items: center;
}

.searchHistory {
    display: inline-flex;
    flex-flow: row-reverse;
}

.searchBox {
    width: 80%;
    display: flex;
    flex-direction: row;
    align-content: center;
    align-items: center;
    justify-content: center;

    .vin-inputcls {
        width: 400px;
    }
}

.el-upload-dragger {
    width: 604px;
    height: 40px;
    display: flex;
    flex-direction: row;
    align-items: center;

    .upload-btn {
        width: 100px;
        height: 30px;
        padding-top: 5px;
        margin-top: 5px;
        margin-bottom: 5px;
        margin-left: 5px;
        margin-right: 20px;
        background-color: orange;
        color: white;
        align-items: center;
        justify-content: center;
        border-radius: 4px;
    }
}

#epc-veh-dialog {
    position: absolute;
    top: 0;
    left: 50%;
    right: auto;
    bottom: auto;
    width: 10px;
    height: 10px;
    overflow: visible;

    .el-dialog {
        box-shadow: 0 0 9px 3px #999;
    }

    .el-dialog__body {
        height: calc(100% - 54px);
        overflow: auto;
    }
}
</style>
<style lang="less">
.vin-input {
    li {
        display: flex;
        flex-direction: row;
        line-height: normal;
        padding: 7px;

        .i-text {
            font-size: 12px;
            color: #b4b4b4;
            margin-left: 10px;
        }

        .highlighted .i-text {
            color: #ddd;
        }
    }
}
</style>
